'use strict';

var vendorConsents = require('./vendor-consents.js');
var localStorageUtils = require('./localStorageUtils.js');
var logger = require('./logger.js');

var permutive = window.permutive;
const CONSENT_STORAGE_KEY = 'consentData'; // Match the key from consent manager

function onConsentGranted() {
	permutive.consent({ 'opt_in': true, 'token': 'CONSENT_CAPTURED' });
	logger.info('Permutive consent has been granted - data will be collected');
}

function onConsentRefused() {
	logger.info('Permutive consent has not been granted - no data will be collected');
	permutive.consent({ 'opt_in': false });
}

module.exports = {
	init: function () {
		var storedConsent = localStorageUtils.getItem(CONSENT_STORAGE_KEY);
		if (!storedConsent) {
			logger.warning('Failed to initialise permutive: No consent data');
			return;
		}

		if (storedConsent.type === 'none') {
			onConsentGranted();
			return;
		}

		const hasPermutiveConsent = storedConsent.consentedVendors.includes(vendorConsents.vendorIds.permutive);
		if (hasPermutiveConsent) {
			onConsentGranted();
		} else {
			onConsentRefused();
		}
	}
};